import { State, StateContext, Action, Selector } from '@ngxs/store';
import { QuickSets } from '../../models/QuickSets';
import { AddQuickSet, RemoveQuickSet } from '../actions/quickSet.action';

export class QuickSetModal {
  quickSet: QuickSets;
}

@State({
  name: 'quickSet',
  defaults: {
    quickSet: undefined,
  },
})
export class QuickSetState {
  @Selector()
  static getQuickSet(state: QuickSetModal) {
    return state.quickSet;
  }

  @Action(AddQuickSet)
  add(
    { getState, patchState }: StateContext<QuickSetModal>,
    { payload }: AddQuickSet
  ) {
    patchState({ quickSet: payload });
  }

  @Action(RemoveQuickSet)
  remove({ patchState }: StateContext<QuickSetModal>) {
    patchState({ quickSet: undefined });
  }
}
